Kubrick.Video = {

  _selectors: ".bit.video",
  _configs:[],
  _controllers:[],

  start: function(config) {
    Kubrick._log("Video: Configuring...", config);
    let $THUMB = document.querySelector("#content .block .bit." + config.video_id);
    let $MODAL = document.querySelector("#content .block #" + config.modal_id);
    this._setupPlayer($THUMB, $MODAL);
  },

  _setupPlayer: function($THUMB, $MODAL) {
    Kubrick._log("Video: Configuring...", $THUMB, $MODAL);
    var $BUTTON = $THUMB.querySelector(".play");

    var controller = {
      $THUMB: $THUMB,
      $MODAL: $MODAL,
      $BUTTON: $BUTTON
    };

    $BUTTON.addEventListener("click", function(e) {
      Kubrick._log("Video: Open and play...",  controller);
      Kubrick.Modals.openModal($MODAL);
    });

    this._controllers.push(controller);
  }
};
